import React from 'react'
import { Row, Col, Button } from '@gympass/yoga'
import { FormattedMessage } from 'react-intl'

import useContact from '@hooks/useContact'
import { Img2d05 } from '@gympass/yoga-illustrations'

import Image from '@components/Image'
import Appbar from '@components/Appbar'

import { Logo, Slogan } from '@assets/logos'
import { virtualTraining, employeesDatabase } from '@assets'

import SummaryCard from './components/SummaryCard'

import * as Style from './Success.style'

export default function Success() {
  const { contact } = useContact()

  return (
    <>
      <Appbar />
      <Style.Header>
        <Style.Container>
          <Style.WrapperTitle>
            <Col xxs={12} xl-start={2} xl={4}>
              <Img2d05
                width={230}
                height={230}
                role="figure"
                aria-label="i2s-settings-modal"
              />

              <Style.Title>
                <FormattedMessage id="smb_acquisition_thankyou.success.header.title" />
              </Style.Title>

              <Style.Subtitle>
                <FormattedMessage
                  id="smb_acquisition_thankyou.success.header.subtitle"
                  values={{
                    contactEmail: contact.email,
                    strong: (...chunks) => <strong>{chunks}</strong>,
                  }}
                />
              </Style.Subtitle>
            </Col>

            <Col xxs={12} xl-start={8} xl={4}>
              <SummaryCard contact={contact} />
            </Col>
          </Style.WrapperTitle>
        </Style.Container>
      </Style.Header>

      <Style.Payment>
        <Style.Container>
          <Row>
            <Col xxs={12} xl-start={2} xl={10}>
              <Style.Heading>
                <FormattedMessage id="smb_acquisition_thankyou.success.how_payment_works.title" />
              </Style.Heading>
              <Style.PaymentDescriptionWrapper>
                <Style.Body1>
                  <FormattedMessage
                    id="smb_acquisition_thankyou.success.how_payment_works.paragraph_1"
                    values={{
                      strong: (...chunks) => <strong>{chunks}</strong>,
                    }}
                  />
                </Style.Body1>

                <Style.Body1>
                  <FormattedMessage
                    id="smb_acquisition_thankyou.success.how_payment_works.paragraph_2"
                    values={{
                      strong: (...chunks) => <strong>{chunks}</strong>,
                    }}
                  />
                </Style.Body1>
              </Style.PaymentDescriptionWrapper>
            </Col>
          </Row>
        </Style.Container>
      </Style.Payment>

      <Style.NextSteps>
        <Style.Container>
          <Row>
            <Col xxs={12} xl-start={2} xl={10}>
              <Style.Heading>
                <FormattedMessage id="smb_acquisition_thankyou.success.next_steps.title" />
              </Style.Heading>
              <Style.Subtitle>
                <FormattedMessage id="smb_acquisition_thankyou.success.next_steps.subtitle" />
              </Style.Subtitle>
            </Col>

            <Col xxs={12} xl-start={2} xl={5}>
              <Style.NextStepItem>
                <Style.NextStepIcon
                  src={virtualTraining}
                  alt="Notebook aberto com um cubo no centro do monitor"
                />
                <Style.NextStepContent>
                  <Style.NextStepTitle>
                    <FormattedMessage id="smb_acquisition_thankyou.success.next_steps.step_1.title" />
                  </Style.NextStepTitle>
                  <Style.Body1>
                    <FormattedMessage id="smb_acquisition_thankyou.success.next_steps.step_1.subtitle" />
                  </Style.Body1>
                  <Button
                    href="https://digital.gympass.com/digital/bem-vindo/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FormattedMessage id="smb_acquisition_thankyou.success.next_steps.step_1.call_to_action.name" />
                  </Button>
                </Style.NextStepContent>
              </Style.NextStepItem>
            </Col>

            <Col xxs={12} xl={5}>
              <Style.NextStepItem>
                <Style.NextStepIcon
                  src={employeesDatabase}
                  alt="Uma folha com vários ticks de checagem"
                />
                <Style.NextStepContent>
                  <Style.NextStepTitle>
                    <FormattedMessage id="smb_acquisition_thankyou.success.next_steps.step_2.title" />
                  </Style.NextStepTitle>
                  <Style.Body1>
                    <FormattedMessage id="smb_acquisition_thankyou.success.next_steps.step_2.subtitle" />
                  </Style.Body1>
                  <Button href="https://bit.ly/3aMEyHp">
                    <FormattedMessage id="smb_acquisition_thankyou.success.next_steps.step_2.call_to_action.name" />
                  </Button>
                </Style.NextStepContent>
              </Style.NextStepItem>
            </Col>
          </Row>
        </Style.Container>
      </Style.NextSteps>

      <Style.FooterWrapper>
        <Style.Container>
          <Style.FooterContent>
            <Style.LogoWrapper>
              <Image src={Logo} alt="Gympass escrito em laranja" />
              <Image
                src={Slogan}
                alt='Slogan do Gympass escrito em laranja "helping people find an activity to love"'
              />
            </Style.LogoWrapper>

            <Style.TextTiny>
              &copy; 2012-{new Date().getFullYear()}{' '}
              <FormattedMessage id="smb_acquisition_thankyou.success.footer.rights" />
            </Style.TextTiny>
          </Style.FooterContent>
        </Style.Container>
      </Style.FooterWrapper>
    </>
  )
}
